import { InstalledUpiApp } from '../utils/installedUpiIntents'
import { resolveUpiAppDisplay } from '../utils/mf-execution/upiAppConfig'

/** Dev-only UPI app list so AutopayMethodsScreen / PaymentMethodsScreen work without Flutter. */
const MOCK_UPI_PACKAGE_NAMES = [
  'com.google.android.apps.nbu.paisa.user',
  'com.phonepe.app',
  'net.one97.paytm',
  'com.dreamplug.androidapp'
] as const

function buildMockInstalledUpiApp(packageName: string): InstalledUpiApp {
  const resolved = resolveUpiAppDisplay(packageName)

  return {
    name: resolved.name,
    packageName,
    appLogoUrl: resolved.logoUrl
  }
}

export const mockInstalledUpiIntents: InstalledUpiApp[] = MOCK_UPI_PACKAGE_NAMES.map((packageName) =>
  buildMockInstalledUpiApp(packageName)
)

/** Flutter/localStorage payload shape consumed by `parseInstalledUpiApps`. */
export function getMockInstalledUpiIntentsStoragePayload(): string {
  return JSON.stringify({ upiApps: mockInstalledUpiIntents })
}
